import { inject, Injectable } from '@angular/core';

import en from './en.json';
import es from './es.json';
import type { TranslationDictionary } from './translation.model';
import { interpolate, resolveTranslationKey } from './translation.util';
import { LocaleService } from '../services/locale.service';

const DICTIONARIES: Record<'es' | 'en', TranslationDictionary> = { en, es };

/**
 * Injectable translation lookup for use outside templates (component/service code —
 * e.g. validation messages built in .ts files). Templates should prefer the `translate`
 * pipe instead; both share this same resolution logic.
 */
@Injectable({ providedIn: 'root' })
export class TranslateService {
  private readonly localeService = inject(LocaleService);

  translate(key: string, params?: Record<string, string | number>): string {
    const dictionary = DICTIONARIES[this.localeService.locale()];
    const value = resolveTranslationKey(dictionary, key);

    if (typeof value !== 'string') {
      if (typeof ngDevMode === 'undefined' || ngDevMode) {
        console.warn(`[TranslateService] Missing translation key: "${key}"`);
      }
      return key;
    }

    return params ? interpolate(value, params) : value;
  }
}
